import { PriceType } from '../../components/HorizontalSubscriptionCard/types.js';
import { OfferSubCategory } from '../enums.js';
import { eurosPerMonthCapMsg, eurosPerMonthMsg, t } from '../i18n';
import { eurosToCents, formatSumToString } from './priceUtils.js';
import { getPriceFromType, getProductOfferingPriceDataFromType } from './productOfferingsUtils.js';
import type { ProductOfferingPrice } from '../../generated/api/productOfferingPrice.js';
import type { ProductOfferingsResponse } from '../../generated/api/productOfferingsResponse.js';

export const formatOneTimePriceCoCo = (euros: number) => formatSumToString(eurosToCents(euros));

export const formatMonthlyPriceCoCo = (euros: number) =>
  `${formatSumToString(eurosToCents(euros), true)} ${t.H37G(eurosPerMonthMsg)}`;

export const formatProductOfferingPrice = (price: ProductOfferingPrice | undefined): string => {
  const amount = formatSumToString(eurosToCents(price?.priceWithoutTax ?? 0), true);

  return price?.priceType === PriceType.RECURRING_CHARGE ? `${amount} ${t.H37G(eurosPerMonthCapMsg)}` : `${amount} €`;
};

/** Returns the monthly price in cents, preferring the lowest installment term for EPP devices. */
export const getDeviceMonthlyPrice = (
  offer: Pick<ProductOfferingsResponse, 'productOfferingPrice' | 'productOfferingType'>
): number => {
  const recurringPrice = getProductOfferingPriceDataFromType(offer.productOfferingPrice, PriceType.RECURRING_CHARGE);
  const termPrices = (recurringPrice?.installmentTerm ?? [])
    .map(term => term.priceWithoutTax)
    .filter((price): price is number => price !== undefined);
  return termPrices.length > 0 &&
    (offer.productOfferingType.subcategory === OfferSubCategory.EPP_DEVICE_POT ||
      recurringPrice?.priceWithoutTax === undefined)
    ? eurosToCents(Math.min(...termPrices))
    : getPriceFromType(offer.productOfferingPrice, PriceType.RECURRING_CHARGE);
};
